import { Typography } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import React from 'react';
import { withRouter } from 'react-router-dom';
import BasicLayout from '../BasicLayout';
import SecondaryButton from '../SecondaryButton';
import { globalStyles } from '../style/gstheme';
import { sortByProp } from '../utils/utils';
import InviteHandler from './InviteHandler';
import SelectSubscriptionCard from './SelectSubscriptionCard';

const styles = Object.assign({
    selectedText: {
        backgroundColor: '#e0e0e0',
        padding: 20,
        borderRadius: 4,
        marginBottom: 12
    },
    unselectedText: {
        padding: 20,
        borderRadius: 4,
        backgroundColor: '#f5f5f5',
        marginBottom: 12,
        '&:hover': {
            cursor: 'pointer',
            backgroundColor: '#aaaaaa'
        }
    }
}, globalStyles);

class SubscriptionSelectorDialog extends React.Component {

    exitSelectSubscription = () => {
        this.props.onExitSelection();
    };

    render() {

        const { classes, subscriptions, onSelectSubscription, rejectedInvitations } = this.props;
        const orderedSubs = sortByProp([...subscriptions], 'subscriptionName');

        return (
            <BasicLayout displaySubscription={false}>
                <div style={{ padding: '0px 80px' }}>
                    <Typography className={classes.mainHeadingLarge} style={{textAlign: 'center'}}>Select a Subscription</Typography>
                    {subscriptions && subscriptions.length > 0 && <Typography paragraph className={classes.subMainHeading}>Owned</Typography>}
                    {subscriptions && orderedSubs.map((subscription) =>
                        <SelectSubscriptionCard
                            key={subscription.id}
                            subscriptionIRI={subscription.id}
                            onSelectSubscription={onSelectSubscription}
                            name={subscription.subscriptionName}
                            subscriptionPackage={subscription.subscriptionPackage}
                            expirationDate={subscription.expirationDate}
                        />
                    )}
                    <InviteHandler allowReject={false} addLinks={true} rejectedInvitations={rejectedInvitations} />
                </div>
                <div style={{clear: 'both', textAlign: 'center', paddingTop: 5, marginBottom: 20}}>
                    <SecondaryButton dataTest="no-subscription" onClick={this.exitSelectSubscription}>Proceed Without Selecting</SecondaryButton>
                </div>
            </BasicLayout>
        );
    }
}

SubscriptionSelectorDialog.defaultProps = {
    subscriptions: [],
    rejectedInvitations: []
};

SubscriptionSelectorDialog.propTypes = {
    classes: PropTypes.object,
    rejectedInvitations: PropTypes.array,
    subscriptions: PropTypes.array.isRequired,
    onSelectSubscription: PropTypes.func.isRequired
};

export default withRouter(withStyles(styles)(SubscriptionSelectorDialog));
